/* eslint-disable @typescript-eslint/no-explicit-any */
import { AbstractControl, FormGroup } from '@angular/forms';

export function getFormControl(
  controlName: string,
  form: FormGroup,
): AbstractControl<any, any> {
  return form.controls[controlName];
}

export function setNumericStringToInteger(
  valueToParse: string | number,
): number {
  return parseInt(valueToParse + '', 10);
}
